export { default } from './TasksListNewTasks';



// WEBPACK FOOTER //
// ./src/components/Tasks/TasksListNewTasks/index.js